import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./ProfileInformation.scss";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import { setUser } from "../../Redux/Actions";

const ProfileInformation = (props) => {
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [chassisNumber, setChassisNumber] = useState("");
  const [address, setAddress] = useState("");
  const [token, setToken] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [citiesLoader, setCitiesLoader] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [letters, setLetters] = useState([]);
  const [plate, setPlate] = useState({
    firstNum: "",
    letter: "",
    lastNum: "",
    cityNum: "",
  });
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const getNstwIdHandler = (id) => {
    let found = id ? provinces.filter((i) => i.id == id) : [];
    console.log("found", found);
    if (found.length > 0) {
      return found[0].nstwProvinceId;
    } else {
      return "";
    }
  };

  useEffect(async () => {
    await getLetters();
    await getProvinces();
    setMobile(user[0]?.mobile);
    setFullName(user[0]?.name);
    setNationalCode(user[0]?.nationalCode);
    setChassisNumber(user[0]?.chassisNumber);
    setEngineNumber(user[0]?.engineNumber);
    // setSelectedProvince(getNstwIdHandler(user[0]?.provinceId));
    // setSelectedCity(user[0]?.cityId);
    setAddress(user[0]?.address);
    setPlate({
      firstNum: user[0]?.plateNO1,
      letter: user[0]?.plateLetter,
      lastNum: user[0]?.plateNO2,
      cityNum: user[0]?.plateSerial,
    });
    if (user[0]?.plateNO1 && user[0]?.plateLetter && user[0]?.plateNO2 && user[0]?.plateSerial) {
      let target = document.querySelector(`.letterOption[value=${user[0]?.plateLetter}]`);
      target.selected = true;
    }
    setToken(user[0]?.token);
  }, []);

  useEffect(async () => {
    if (user[0]?.provinceId) {
      let final = getNstwIdHandler(user[0]?.provinceId);
      console.log("final", final);
      setSelectedProvince(final);
      await getCities(final, true);
    }
    if (user[0]?.cityId) {
      setSelectedCity(user[0]?.cityId);
    }
  }, [provinces]);

  const getLetters = async () => {
    await fetch(`${Config.apiPath}/plateletters`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) setLetters(resJson.data);
    });
  };
  const getProvinces = async () => {
    await fetch(`${Config.apiPath}/api/provinces`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) {
        setProvinces(resJson.data);
      }
    });
  };

  const fullNameHandler = (e) => {
    setFullName(e.target.value);
  };

  const mobileHandler = (e) => {
    setMobile(e.target.value);
  };

  const getIdHandler = (id) => {
    let found = id ? provinces.filter((i) => i.nstwProvinceId == id) : [];
    if (found.length > 0) {
      return found[0].id;
    } else {
      return "";
    }
  };

  const registerNameHandler = () => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    let raw = JSON.stringify({
      fullName: fullName,
      nationalCode: nationalCode,
      chassisNumber: chassisNumber,
      engineNumber: engineNumber,
      plateNO1: parseInt(plate.firstNum),
      plateLetter: plate.letter,
      plateNO2: parseInt(plate.lastNum),
      plateSerial: parseInt(plate.cityNum),
      provinceId: getIdHandler(selectedProvince) || null,
      cityId: selectedCity || null,
      address: address || null,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    if (!fullName) {
      toast.error("نام و نام خانوادگی خود را وارد کنید");
      return;
    }
    if (plate.cityNum || plate.lastNum || plate.letter || plate.firstNum) {
      if (plate.cityNum.length < 2 || plate.lastNum.length < 3 || !plate.letter || plate.firstNum.length < 2) {
        toast.error("لطفا پلاک را به درستی وارد نمایید");
        return;
      }
    }
    // else if (nationalCode.length < 10) {
    //   toast.error("کد ملی باید بیشتر از 9 عدد باشد");
    //   return;
    // } else if (!chassisNumber) {
    //   toast.error("شماره شاسی ناوگان را وارد کنید");
    //   return;
    // } else if (!engineNumber) {
    //   toast.error("شماره موتور را وارد نمایید");
    //   return;
    // }
    setShowSpinner(true);

    fetch(Config.apiPath + "/account/changeUserInfo", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          let user = {
            mobile: mobile,
            token: token,
            name: fullName,
            nationalCode: nationalCode,
            chassisNumber: chassisNumber,
            engineNumber: engineNumber,
            plateNO1: plate.firstNum,
            plateLetter: plate.letter,
            plateNO2: plate.lastNum,
            plateSerial: plate.cityNum,
            provinceId: getIdHandler(selectedProvince) || null,
            cityId: selectedCity || null,
            address: address || null,
          };
          dispatch(setUser(user));
          toast.success(<div>{result.messages}</div>);
          setShowSpinner(false);
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        // console.log(error);
        setShowSpinner(false);
      });
  };

  const plateChangeHandler = (type, e) => {
    let pattern = /^[0-9]+$/;
    if (type === "firstNum") {
      setPlate({ ...plate, firstNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, firstNum: "" });
      }
    } else if (type === "lastNum") {
      setPlate({ ...plate, lastNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, lastNum: "" });
      }
    } else if (type === "letter") {
      setPlate({ ...plate, letter: e.target.value });
    } else if (type === "cityNum") {
      setPlate({ ...plate, cityNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, cityNum: "" });
      }
    }
  };

  const setProvinceHandler = async (e) => {
    setSelectedProvince(e.target.value);
    setSelectedCity("");
    setCitiesLoader(true);
    await getCities(e.target.value);
  };

  const getCities = async (id, isDef) => {
    await fetch(`${Config.apiPath}/api/cities/getCityWithFilter/${id}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) {
        setCities(resJson.data);
        if (isDef) {
          if (user[0]?.cityId) {
            setSelectedCity(user[0]?.cityId);
          }
        }
        setCitiesLoader(false);
      }
      setCitiesLoader(false);
    });
  };

  return (
    <div className="ProfileInformation">
      <div className="formWrapper">
        <span className="formHeader">اطلاعات کاربری</span>
        <div className="formInputsWrapper">
          <div className="formInput">
            <label className="formLabel">نام و نام خانوادگی</label>
            <input className="input" type="text" value={fullName} onChange={(e) => fullNameHandler(e)} />
          </div>
          <div className="formInput">
            <label className="formLabel">شماره موبایل</label>
            <input className="input fill" type="text" value={mobile} onChange={(e) => mobileHandler(e)} />
          </div>
          <div className="formInput">
            <label className="formLabel">کدملی</label>
            <input
              className="input"
              type="text"
              value={nationalCode}
              onChange={(e) => setNationalCode(e.target.value)}
            />
          </div>
          <div className="formInput">
            <label className="formLabel">شماره موتور</label>
            <input
              className="input"
              type="text"
              value={engineNumber}
              onChange={(e) => setEngineNumber(e.target.value)}
            />
          </div>
          <div className="formInput">
            <label className="formLabel">شماره شاسی ناوگان</label>
            <input
              className="input"
              type="text"
              value={chassisNumber}
              onChange={(e) => setChassisNumber(e.target.value)}
            />
          </div>
          <div className="formInput">
            <label className="formLabel">شماره پلاک</label>
            <div className="inputWrapper">
              <input
                type="text"
                onChange={(e) => plateChangeHandler("cityNum", e)}
                maxLength={2}
                placeholder="11"
                pattern="/[0-9]/gm"
                className="tag lastNum"
                value={plate.cityNum}
              />
              <input
                type="text"
                value={plate.lastNum}
                maxLength={3}
                placeholder="- - -"
                onChange={(e) => plateChangeHandler("lastNum", e)}
                className="tag num"
              />
              <select className="tag" onInput={(e) => plateChangeHandler("letter", e)}>
                <option disabled selected>
                  x
                </option>
                {letters.map((i, index) => {
                  return (
                    <option className="letterOption" value={i}>
                      {i}
                    </option>
                  );
                })}
              </select>
              <input
                type="text"
                maxLength={2}
                placeholder="- -"
                onChange={(e) => plateChangeHandler("firstNum", e)}
                className="tag num"
                value={plate.firstNum}
              />
            </div>
          </div>
          <div className="formInput">
            <label className="formLabel">استان</label>
            <div className="inputWrapper">
              <select className="tag full" value={selectedProvince} onInput={(e) => setProvinceHandler(e)}>
                <option disabled selected value="">
                  لطفا انتخاب کنید
                </option>
                {provinces.map((i, index) => {
                  return (
                    <option className="letterOption" value={i.nstwProvinceId} key={index}>
                      {i.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="formInput">
            <label className="formLabel">شهر</label>
            <div className="inputWrapper">
              <select className="tag full" value={selectedCity} onInput={(e) => setSelectedCity(e.target.value)}>
                <option disabled selected value="">
                  {cities.length < 1
                    ? "لطفا ابتدا استان را انتخاب کنید"
                    : citiesLoader
                    ? "لطفا صبر کنید"
                    : "انتخاب کنید"}
                </option>
                {cities.map((i, index) => {
                  return (
                    <option className="letterOption" value={i.id} key={index}>
                      {i.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="formInput">
            <label className="formLabel">آدرس</label>
            <input className="input" type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
          </div>
        </div>
        <button className={`submit ${!showSpinner && "active"}`} onClick={() => registerNameHandler()}>
          اعمال تغیرات
        </button>
      </div>
    </div>
  );
};

export default React.memo(withRouter(ProfileInformation));
